import Helper from "./Helper";
import WOW from '../lib/wow';

class Animation {
  constructor(config = {}) {
    const {
      contentSelector,
      wowInstance
    } = config;

    this.contentSelectors = document.querySelectorAll(contentSelector);
    this.contentItem = Array.prototype.slice.call(this.contentSelectors);
    this.wowInstance = wowInstance;

    window.addEventListener('load', () => {
      this.bindScroll();
      this.wowInstance = new WOW({
        boxClass: 'has-animation',
        animateClass: 'animated',
        offset: 250,
        mobile: false
      });
      this.wowInstance.init();
    });
    window.addEventListener('scroll', () => {
      this.bindScroll();
    });
  }

  bindScroll() {
    this.contentItem.forEach(item => {
      if (!item.classList.contains('has-animation')) {
        item.classList.add('has-animation');
      }
      if (Helper.isInViewport(item)) {
        //item.classList.add('animated');
      }
    });
  }
}

export default Animation;
